function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Emoji_Ihearya");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "P_St_A",
  transform: "translate(-465.000000, -482.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(409.000000, 473.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Emoji_Ihearya",
  transform: "translate(56.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "skin",
  fill: "#FCEA2B",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.3084838,4.0628574 C4.0567338,-2.5678674 15.876,-0.756 11.6088714,10.07937 C6.0931332,23.6086326 -0.7863912,19.4073138 0.3712338,14.99337",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "skin-shadow",
  transform: "translate(1.512000, 2.268000)",
  fill: "#F1B31C",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.575875,7.7922432 C9.9607536,-0.4774518 3.07125,1.27575 2.5257582,3.378375 C4.0280436,-2.622375 11.6323452,-0.2475522 8.575875,7.7922432 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.2195762,4.7755386 C5.8973292,7.4215386 7.371,10.0327248 5.103,11.0565 C4.5749718,11.273283 4.015683,11.2126896 3.4464528,11.500083 C2.8664874,11.7731124 2.7587952,12.0015 2.0710998,12.7417374 C1.1024748,13.5213624 -0.1102626,12.1571604 0.5748624,11.3478624 C1.7364186,10.06425 3.0121686,9.8634186 2.338875,8.623125 C1.8782064,7.7897484 2.5262496,6.7226544 4.002831,7.1479044",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "line",
  transform: "translate(0.378000, 0.000000)",
  stroke: "#000000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.756
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.31525,4.01625 C4.0635,-2.6145126 15.498,-0.42525 11.221875,10.1902374 C5.7061368,23.7195 -0.826875,19.6402374 0.33075,15.2262936",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.7089718,7.182 C7.3867626,9.828 8.505,12.3007626 6.237,13.3245 C5.7089718,13.541283 5.149683,13.4806896 4.5804528,13.768083 C4.0004874,14.0411124 3.8927952,14.2695 3.2050998,15.0097374 C2.2364748,15.7893624 1.0237374,14.4251604 1.7088624,13.6158624 C2.8704186,12.33225 4.1461686,12.1314186 3.472875,10.891125 C3.0122064,10.0577484 3.3193314,8.8948314 4.795875,9.3200814",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.6597582,5.646375 C5.1620814,-0.354375 13.046481,1.7687754 9.4204404,9.8490924",
  id: "Path"
}))))));

var SvgEar = function SvgEar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "21px",
    viewBox: "0 0 13 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ear.8cf19423.svg";
export { ForwardRef as ReactComponent };